<template>
    <div class="fan-data">
        <div class="fan-data_header">
            <div class="menu-item is-check">粉丝画像</div>
        </div>

        <el-scrollbar class="fan-data_content">
            <div class="content-multiple">
                <div class="multiple-item" v-for="(value, key) in fan[0]" :key="key">
                    <div class="item-title">{{ value.label }}</div>

                    <div class="item-chart" :ref="value.ref">
                        <el-table
                            v-if="value.isTable"
                            :data="value.data"
                            style="
                            width: 100%;
                            flex: 1;
                            border-radius: 4px;
                        "
                            size="medium"
                            :header-cell-style="{
                                fontWeight: 'normal',
                                color: '#333',
                                background: '#eef2fa',
                            }"
                            :cell-style="{ fontSize: '12px', color: '#333' }"
                            height="100%"
                        >
                            <el-table-column prop="tag" label="兴趣"> </el-table-column>
                            <el-table-column prop="rate" label="占比"> </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <div class="content-compose">
                <div class="compose-title">{{ fan[1].label }}</div>

                <div class="compose-box">
                    <div class="compose-map" ref="mapChartRef"></div>

                    <div class="compose-table">
                        <el-table
                            :data="fan[1].tableData"
                            style="
                            width: 100%;
                            flex: 1;
                            border-radius: 4px;
                        "
                            size="medium"
                            :header-cell-style="{
                                fontWeight: 'normal',
                                color: '#333',
                                background: '#eef2fa',
                            }"
                            :cell-style="{ fontSize: '12px', color: '#333' }"
                            height="100%"
                        >
                            <el-table-column prop="area" label="地区"> </el-table-column>
                            <el-table-column label="占比">
                                <template slot-scope="scope">{{ scope.row.value }}%</template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import fanData from "@/utils/training-data/fan-data.json";
import "@/utils/china.js";

// 地图初始化数据时使用
const province = [
    "台湾",
    "河北",
    "山西",
    "内蒙古",
    "辽宁",
    "吉林",
    "黑龙江",
    "江苏",
    "浙江",
    "安徽",
    "福建",
    "江西",
    "山东",
    "河南",
    "湖北",
    "湖南",
    "广东",
    "广西",
    "海南",
    "四川",
    "贵州",
    "云南",
    "西藏",
    "陕西",
    "甘肃",
    "青海",
    "宁夏",
    "新疆",
    "北京",
    "天津",
    "上海",
    "重庆",
    "香港",
    "澳门",
    "南海诸岛",
];

export default {
    data() {
        return {
            fan: fanData,
        };
    },
    computed: {},
    mounted() {
        this.setActiveChart();
        this.setSexChart();
        this.setDeviceChart();
        this.setFanContributeChart();
        this.setAgeChart();
        this.setMapChart();
    },
    methods: {
        // 设置饼状图
        setPieChart(ref, data, center) {
            const chart = this.$echarts.init(ref);

            const options = {
                legend: {
                    bottom: "1%",
                    left: "center",
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 30,
                    icon: "circle",
                    textStyle: {
                        padding: [2, 0, 0, 0],
                        verticalAlign: "middle",
                    },
                },
                tooltip: {
                    trigger: "item",
                    borderWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    extraCssText: "box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.3)",
                    textStyle: {
                        color: "#323233",
                    },
                    formatter: function(params) {
                        return `
                            <div class="time-tooltip">
                                <div class="time-label">${params.data.name}</div>

                                <div class="time-value">
                                    <div class="icon">
                                        <i style="background-color: ${params.data.color}"></i>占比：
                                    </div>
                                    
                                    <span>${params.data.value}%</span>
                                </div>
                            </div>
                        `;
                    },
                },
                color: data.map((item) => item.color),
                series: [
                    {
                        name: "活跃分布",
                        type: "pie",
                        radius: ["40%", "70%"],
                        center: center,
                        avoidLabelOverlap: true,
                        padAngle: data.length,
                        label: {
                            show: true,
                            position: "outside",
                            formatter: "{d|{d}}%\n{b|{b}}",
                            edgeDistance: 30,
                            lineHeight: 24,
                            rich: {
                                d: {
                                    fontSize: 20,
                                    color: "#252632",
                                },
                                b: {
                                    fontSize: 12,
                                    color: "rgba(37,38,50,0.6)",
                                },
                            },
                            color: "rgba(37, 38, 50, 0.6)",
                        },
                        labelLine: {
                            show: true,
                            length: 20,
                            length2: 20,
                        },
                        data: data,
                        hoverAnimation: false,
                    },
                ],
            };

            chart.setOption(options);
        },

        // 设置柱状图
        setBarChart(ref, data) {
            const chart = this.$echarts.init(ref);

            const options = {
                grid: {
                    left: 35,
                    top: 20,
                    bottom: 35,
                    right: 20,
                },
                tooltip: {
                    trigger: "axis",
                    borderWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    extraCssText: "box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.3)",
                    textStyle: {
                        color: "#323233",
                    },
                    formatter: function(params) {
                        const param = params[0];

                        return `
                            <div class="time-tooltip">
                                <div class="time-label">${param.axisValue}</div>

                                <div class="time-value">
                                    <div class="icon">
                                        <i style="background-color: #398dff"></i>占比：
                                    </div>
                                    
                                    <span>${param.data}%</span>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    data: data.x,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        formatter: function(value) {
                            return `${value}%`;
                        },
                    },
                },
                series: [
                    {
                        data: data.y,
                        type: "bar",
                        itemStyle: {
                            color: "#398dff",
                            barBorderRadius: 5,
                        },
                        barMaxWidth: 12,
                    },
                ],
            };

            chart.setOption(options);
        },

        setActiveChart() {
            if (!this.$refs.activeRef[0]) return;

            const data = this.fan[0].active.data;
            this.setPieChart(this.$refs.activeRef[0], data, ["50%", "40%"]);
        },

        setSexChart() {
            if (!this.$refs.sexRef[0]) return;

            const data = this.fan[0].sex.data;
            this.setPieChart(this.$refs.sexRef[0], data, ["50%", "45%"]);
        },

        setDeviceChart() {
            if (!this.$refs.deviceRef[0]) return;

            const data = this.fan[0].device.data;
            this.setPieChart(this.$refs.deviceRef[0], data, ["50%", "45%"]);
        },

        setFanContributeChart() {
            if (!this.$refs.fanContributeRef[0]) return;

            const data = this.fan[0].fanContribute.data;
            this.setBarChart(this.$refs.fanContributeRef[0], data);
        },

        setAgeChart() {
            if (!this.$refs.ageRef[0]) return;

            const data = this.fan[0].age.data;
            this.setBarChart(this.$refs.ageRef[0], data);
        },

        setMapChart() {
            if (!this.$refs.mapChartRef) return;

            const chart = this.$echarts.init(this.$refs.mapChartRef);

            const data = this.fan[1].areaData;
            console.log(data);

            const options = {
                tooltip: {
                    show: false,
                },
                legend: {
                    show: false,
                },
                visualMap: {
                    type: "continuous",
                    seriesIndex: 0,
                    hoverLink: false,
                    min: 0,
                    max: 150,
                    left: 20,
                    bottom: 20,
                    align: "left",
                    itemWidth: 22,
                    itemHeight: 130,
                    textStyle: {
                        color: "#000000",
                        fontSize: 14,
                        lineHeight: 20,
                    },
                    text: ["高", "低"],
                    inRange: {
                        color: ["#eeeeee", "#81c0ff"],
                    },
                },
                geo: {
                    map: "china",
                    silent: true,
                    select: {
                        show: false,
                    },
                    zoom: 1.2,
                    roam: false, // 地图缩放拖拽
                    itemStyle: {
                        normal: {
                            areaColor: "#9CC2FF", // 地图省份的背景颜色
                            borderColor: "#ffffff",
                            borderWidth: 1,
                        },
                        emphasis: {
                            areaColor: "#9CC2FF", // 地图省份的背景颜色
                            borderColor: "#ffffff",
                        },
                    },
                },
                series: [
                    {
                        name: "地域分布",
                        type: "map",
                        map: "china",
                        geoIndex: 0,
                        data: data,
                    },
                ],
            };
            chart.setOption(options);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .time-tooltip {
    width: 130px;
    height: 60px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 12px;
    gap: 6px;

    .time-value {
        display: flex;
        justify-content: space-between;
        width: 100%;

        i {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            display: inline-block;
            margin-right: 6px;
        }
    }
}

::v-deep .el-table__body-wrapper {
    /* 整个滚动条 */
    &::-webkit-scrollbar {
        width: 6px; /* 纵向滚动条宽度 */
        height: 6px; /* 横向滚动条高度 */
    }

    /* 滚动条轨道（背景部分） */
    &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px; /* 轨道圆角 */
    }

    /* 滚动条滑块（可拖动的部分） */
    &::-webkit-scrollbar-thumb {
        background: #cfd2d9;
        border-radius: 10px;
    }

    /* 鼠标悬停时的滑块 */
    &::-webkit-scrollbar-thumb:hover {
        background: #c7c9cc;
    }
}

.fan-data {
    width: 100%;
    height: 100%;

    &_header {
        margin: 16px 24px 0;
        background-color: #ffffff;
        height: 64px;
        margin-bottom: 0;
        padding: 0 24px;
        box-shadow: 0 2px 8px #00000014;
        border-radius: 12px;
        display: flex;
        align-items: center;

        .menu-item {
            height: 100%;
            font-size: 16px;
            color: #323235;
            line-height: 64px;
            position: relative;
            cursor: pointer;

            &.is-check {
                font-weight: 600;

                &::before {
                    position: absolute;
                    content: "";
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background-color: #2a55e5;
                }
            }
        }
    }

    &_content {
        height: calc(100% - 96px);
        margin-inline: 24px;
        // background-color: red;
        box-sizing: border-box;
        margin-top: 16px;

        ::v-deep .el-scrollbar__wrap {
            margin: 0 !important;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        ::v-deep .el-scrollbar__bar.is-vertical {
            display: none;
        }

        .content-multiple {
            display: flex;
            flex-wrap: wrap;
            gap: 16px 24px;

            .multiple-item {
                flex-shrink: 0;
                width: calc((100% - 24px) / 2);
                background-color: #ffffff;
                border-radius: 12px;
                height: 377px;
                box-sizing: border-box;
                padding: 32px;

                .item-title {
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    margin-bottom: 24px;
                    color: #161823;
                }

                .item-chart {
                    height: calc(100% - 44px);
                }
            }
        }

        .content-compose {
            height: 421px;
            background-color: #ffffff;
            border-radius: 12px;
            box-sizing: border-box;
            margin-block: 16px;
            padding: 32px;

            .compose-title {
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                margin-bottom: 24px;
                color: #161823;
            }

            .compose-box {
                height: calc(100% - 44px);
                // background-color: rgba(0, 0, 0, 0.1);
                display: flex;
                justify-content: space-between;
                gap: 24px;

                .compose-map,
                .compose-table {
                    width: calc((100% - 24px) / 2 - 32px);
                    height: 100%;
                    // background-color: blue;
                }
            }
        }
    }
}
</style>
